import React, { useState, useEffect } from "react";
import { useRouteMatch, Link } from "react-router-dom";
import { format } from "date-fns";
import { EditableLabel } from "./EditableLabel";

export default function Header({
  booking_link,
  property_name,
  property_street,
  property_city,
  property_state,
  property_postal_code,
  updated_at,
  update,
  serverResponse,
  serverResponseReset,
  readOnly,
  guestInfo,
  children,
  maxWidth,
}) {
  const matchHotelPage = useRouteMatch("/hotel_partners/:uuid");
  const matchGuestPage = useRouteMatch(
    "/hotel_partners/:uuid/contracts/:confirmation_number"
  );
  const hotelPage = matchHotelPage && matchHotelPage.isExact;
  const guestPage = matchGuestPage && matchGuestPage.isExact;

  const [updatedBookingLink, setUpdatedBookingLink] = useState(booking_link);

  const onChange = (e) => {
    setUpdatedBookingLink(e.target.value);
  };

  useEffect(() => {
    setUpdatedBookingLink(booking_link);
  }, [booking_link]);

  return (
    <div
      className={`block w-full max-w-2xl ${
        maxWidth ? maxWidth : "lg:max-w-3xl"
      }`}>
      <div className="flex flex-col items-center flex-wrap md:flex-row md:justify-between">
        <Link to={matchHotelPage.url}>
          <img
            src={process.env.PUBLIC_URL + "/HE_Logo.png"}
            alt="Hotel Engine"
            className="logo sm:px-0"
          />
        </Link>
        {(hotelPage || guestPage) && (
          <Link
            to={(location) => {
              const to = guestPage
                ? matchGuestPage.path
                    .replace(":uuid", matchGuestPage.params.uuid)
                    .replace("/:confirmation_number", "")
                : `${location.pathname}/contracts`;
              return to;
            }}
            className="bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 rounded shadow self-end mr-6 mb-4 md:self-center md:mr-0 md:mb-0 md:-mt-2">
            View Bookings
          </Link>
        )}
      </div>
      <div className="flex flex-col w-full max-w-2xl md:max-w-3xl justify-between mb-3 px-6 sm:px-0 md:flex-row md:items-end">
        <div className="flex flex-col flex-1 w-full md:truncate md:w-auto">
          <div className="font-bold text-base">{property_name || ""}</div>
          <div className="font-semibold text-gray-800 text-sm">{`${
            property_street ? `${property_street},` : ""
          } ${property_city ? `${property_city},` : ""} ${
            property_state ? `${property_state}` : ""
          } ${property_postal_code || ""}`}</div>
          {!readOnly && (
            <div className="flex flex-col font-semibold text-black text-sm mt-2 mb-3 md:truncate md:mb-0">
              <EditableLabel
                label={updatedBookingLink}
                onChange={onChange}
                update={() => update({ booking_link: updatedBookingLink })}
                serverResponse={serverResponse}
                reset={serverResponseReset}
                readOnly={readOnly}
              />
            </div>
          )}
        </div>
        {!readOnly && updated_at && (
          <div className="flex flex-1 text-sm w-full items-end mt-2 md:flex-col md:w-auto md:mt-0">
            <span className="text-xs text-gray-700 uppercase mr-2 md:mr-0">
              Last Updated:
            </span>
            <span className="font-semibold text-gray-800">
              {format(
                new Date(updated_at),
                "eee, MMM do, yyy ' at ' h:mm aaaa"
              )}
            </span>
          </div>
        )}
        {guestInfo && (
          <div className="flex flex-1 text-sm w-full justify-end items-center mt-2 md:w-auto md:mt-0">
            <span className="font-semibold text-black uppercase mr-2">
              {guestInfo.guest_name ||
                (guestInfo.guest_first &&
                  guestInfo.guest_last &&
                  `${guestInfo.guest_first} ${guestInfo.guest_last}`)}
            </span>
            <span className="text-xs text-gray-700">
              {guestInfo.guest_unique_id && `(${guestInfo.guest_unique_id})`}
            </span>
          </div>
        )}
        {children}
      </div>
    </div>
  );
}
